
import React from 'react';
import { cn } from '@/lib/utils';

export interface ProgressBarProps {
  label: string;
  value: number;
  icon?: React.ReactNode;
  color?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ 
  label, 
  value, 
  icon,
  color = "bg-neon-purple"
}) => {
  return (
    <div>
      <div className="flex justify-between items-center mb-1.5">
        <span className="text-sm flex items-center gap-1.5 text-white/95 font-medium">
          {icon && <span className="text-white/90">{icon}</span>}
          <span>{label}</span>
        </span>
        <span className="font-medium text-white">{value}%</span>
      </div>
      <div className="bg-black/40 backdrop-blur-sm rounded-full h-2.5 overflow-hidden border border-white/20 relative">
        <div 
          className={`${color} h-full rounded-full relative overflow-hidden`} 
          style={{ width: `${value}%` }}
        >
          {/* Add shimmer effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shine"></div>
          
          {/* Add subtle glow dot at the end of the progress */}
          {value > 5 && (
            <div className="absolute top-1/2 right-0 transform -translate-y-1/2 h-3 w-3 rounded-full bg-white/90 shadow-lg blur-[1px]"></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
